import { useMemo } from 'react';

import { CareerPath, CareerCategory, Industry } from '@backrs_ui/common-ui';

import {
  useDynamicDefaultCareerPathCategories,
  useDynamicInternshipCategories,
} from './useDynamicInternshipCategories';
import {
  SEARCH_PARENT_CATEGORIES_SCHOLARSHIPS,
  SEARCH_PARENT_CATEGORIES_COLLEGES,
} from '../search.config';
import { SEARCH_PAGE_CATEGORIES, SearchParentCategory } from '../search.types';

type UseSearchPageCategoryFilterMapProps = Readonly<{
  careerPaths: CareerPath[];
  careerCategories: CareerCategory[];
  industries: Industry[];
}>;

export const useSearchPageCategoryFilterMap = ({
  careerPaths,
  careerCategories,
  industries,
}: UseSearchPageCategoryFilterMapProps): Record<string, SearchParentCategory[]> => {
  // we filter internships based on career paths and industries that come from the BE
  const dynamicInternshipCategories = useDynamicInternshipCategories(
    industries,
    careerCategories,
    careerPaths,
  );

  const defaultCareerPathCategories = useDynamicDefaultCareerPathCategories(careerPaths);

  return useMemo(
    () => ({
      [SEARCH_PAGE_CATEGORIES.DEFAULT]: defaultCareerPathCategories,
      [SEARCH_PAGE_CATEGORIES.SCHOLARSHIPS]: Object.values(SEARCH_PARENT_CATEGORIES_SCHOLARSHIPS),
      [SEARCH_PAGE_CATEGORIES.INTERNSHIPS]: dynamicInternshipCategories,
      [SEARCH_PAGE_CATEGORIES.COLLEGES]: Object.values(SEARCH_PARENT_CATEGORIES_COLLEGES),
    }),
    [dynamicInternshipCategories, defaultCareerPathCategories],
  );
};
